import { MapPin, Baby, Bicycle, PersonSimpleRun, Waves, Envelope, Cookie, Headphones, AirplaneTakeoff, BehanceLogo, LinkedinLogo, Campfire } from 'phosphor-react';
import { Hline } from "../../../components/icons/all-icons";
import resume from "./Resume.module.css"
import shared from "../SharedCSS.module.css"
import ResumeData from "../../../data/ResumeData"
import Card from "../../../components/00_resume/Card";
import LanguageCard from "../../../components/00_resume/LanguageCard";
import BulletPercentage from "../../../components/00_resume/BulletPerc";

function Resume() {

    const data = ResumeData;

    const CSSHline = `${shared.hline} ${resume.hline}`;
    
    return (
        <main id="resume" className={`${shared.main} ${resume.main}`}>
            <div className={shared.header}>
                <p>CURRICULUM VITAE  —  <span>{data?.cvDate}</span></p>
                <div className={shared.me}>
                    <h1>Kian <br/>Segantini</h1>
                    <p>UX|UI DESIGNER</p>
                </div>
            </div>
            <div className={`${shared.links} ${resume.links}`}>
                <div className={`${shared.other} ${resume.other}`}><MapPin className={`${`${shared.icons} ${resume.icons}`} ${resume.icons}`}/>{data?.links?.location}</div>
                <div className={`${shared.other} ${resume.other}`}><Baby className={`${shared.icons} ${resume.icons}`}/>January 16th, 2009</div>
                <div className={`${shared.other} ${resume.other}`}><Waves className={`${shared.icons} ${resume.icons}`}/><Bicycle className={`${shared.icons} ${resume.icons}`}/><PersonSimpleRun className={`${shared.icons} ${resume.icons}`}/></div>
                <a href={data?.links?.mail} target="_blank" rel="noreferrer" className={`${shared.link} ${resume.link}`}><Envelope className={`${shared.icons} ${resume.icons}`}/></a>
                <a href="/real-life-resume" className={`${shared.other} ${resume.other}`}><Campfire className={`${shared.icons} ${resume.icons}`}/><Cookie className={`${shared.icons} ${resume.icons}`}/><Headphones className={`${shared.icons} ${resume.icons}`}/><AirplaneTakeoff className={`${shared.icons} ${resume.icons}`}/></a>
                <a href={data?.links?.behance} target="_blank" rel="noreferrer" className={`${shared.link} ${resume.link}`}><BehanceLogo className={`${shared.icons} ${resume.icons}`}/></a>
                <a href={data?.links?.linkedin} target="_blank" rel="noreferrer" className={`${shared.link} ${resume.link}`}><LinkedinLogo className={`${shared.icons} ${resume.icons}`}/></a>
            </div>
            <div className={`${shared.resumeSection} ${shared.introduction}`}>
                <div className={`${shared.sectionTitle} ${resume.sectionTitle}`}>
                    <h2>{data?.sectionTitles[0]}</h2>
                    <Hline className={CSSHline} />
                </div>
                <p>{data?.introduction?.text}</p>
            </div>
            <div className={`${shared.resumeSection} ${shared.education}`}>
                <div className={`${shared.sectionTitle} ${resume.sectionTitle}`}>
                    <h2>{data?.sectionTitles[1]}</h2>
                    <Hline className={CSSHline} />
                </div>
                <div className={shared.cards}>
                    {data?.education?.cards.map((card, index) => (
                        <Card
                            key={index}
                            className={shared.card}
                            start={card.start}
                            end={card.end}
                            title={card.title}
                            subtitle1={card.subtitle1}
                            subtitle2={card.subtitle2}
                        />
                    ))}
                </div>
            </div>
            <div className={`${shared.resumeSection} ${shared.languages}`}>
                <div className={`${shared.sectionTitle} ${resume.sectionTitle}`}>
                    <h2>{data?.sectionTitles[2]}</h2>
                    <Hline className={CSSHline} />
                </div>
                <div className={shared.LGcards}>
                    {data?.languages?.map((lang, index) => (
                        <LanguageCard
                            key={index}
                            language={lang.language}
                            level={lang.level}
                            percentage={lang.percentage}
                            />
                    ))}
                </div>
            </div>
            <div className={`${shared.resumeSection} ${shared.courses}`}>
                <div className={`${shared.sectionTitle} ${resume.sectionTitle}`}>
                    <h2>{data?.sectionTitles[3]}</h2>
                    <Hline className={CSSHline} />
                </div>
                <div className={shared.cards}>
                    {data?.courses?.cards.map((card, index) => (
                        <Card
                            key={index}
                            className={shared.card}
                            start={card.start}
                            end={card.end}
                            title={card.title}
                            subtitle1={card.subtitle1}
                            subtitle2={card.subtitle2}
                        />
                    ))}
                </div>
            </div>
            <div className={`${shared.resumeSection} ${shared.books}`}>
                <div className={`${shared.sectionTitle} ${resume.sectionTitle}`}>
                    <h2>{data?.sectionTitles[4]}</h2>
                    <Hline className={CSSHline} />
                </div>
                <div className={shared.cards}>
                    {data?.books?.cards.map((card, index) => (
                        <Card
                            key={index}
                            className={shared.card}
                            start={card.start}
                            end={card.end}
                            title={card.title}
                            subtitle1={card.subtitle1}
                            subtitle2={card.subtitle2}
                        />
                    ))}
                </div>
            </div>
            <div className={`${shared.resumeSection} ${shared.experience}`}>
                <div className={`${shared.sectionTitle} ${resume.sectionTitle}`}>
                    <h2>{data?.sectionTitles[5]}</h2>
                    <Hline className={CSSHline} />
                </div>
                <div className={shared.cards}>
                    {data?.experience?.cards.map((card, index) => (
                        <Card
                            key={index}
                            className={shared.card}
                            start={card.start}
                            end={card.end}
                            title={card.title}
                            subtitle1={card.subtitle1}
                            subtitle2={card.subtitle2}
                            link={card.link}
                        />
                    ))}
                </div>
            </div>
            <div className={`${shared.resumeSection} ${shared.skills}`}>
                <div className={`${shared.sectionTitle} ${resume.sectionTitle}`}>
                    <h2>{data?.sectionTitles[6]}</h2>
                    <Hline className={CSSHline} />
                </div>
                    <div className={shared.skillpercs}>
                        {data?.skills?.map((lang, index) => (
                            <BulletPercentage key={index} title={lang.title} percentage={lang.percentage} />
                        ))}
                    </div>
            </div>

        </main>
    );
}

export default Resume;
